import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FooterContactUsContainer from "@steiner/App/Components/Footer/FooterContactUsContainer";
import FooterCopyrightContainer from "@steiner/App/Components/Footer/FooterCopyrightContainer";
import FooterInfoLinksContainer from "@steiner/App/Components/Footer/FooterInfoLinksContainer";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    /**
     * XNG-Changes
     */
    container?: InjectableCss;
    infoLinksContainer?: InjectableCss;
    copyrightContainer?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.container} data-test-selector="FooterContainer">
            <FooterContactUsContainer id={id} />
            <FooterInfoLinksContainer id={id} />
            <FooterCopyrightContainer id={id} />
        </StyledWrapper>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
